/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'actions-controls-play-outline-filled': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" d="M10 1.25a8.75 8.75 0 100 17.5 8.75 8.75 0 000-17.5zm4.675 9.3L7.8 14.3a.625.625 0 01-.625 0 .625.625 0 01-.3-.55v-7.5c0-.22.116-.425.306-.537a.625.625 0 01.625 0l6.875 3.75a.625.625 0 010 1.1l-.006-.013zm-6.55 2.15l4.944-2.7-4.944-2.694V12.7z"/>'
  }
})
